import script from "./RegisterPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterPopup.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterPopup.vue?vue&type=style&index=0&id=94ba9112&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94ba9112"]])

export default __exports__